import {Component} from '@angular/core';

@Component({
    selector: 'acabim-user-organisation',
    templateUrl: './organisation.component.html',
    styleUrls: ['./organisation.component.scss']
})
export class OrganisationComponent {

    constructor() {
    }
}
